module.exports = __webpack_public_path__ + "media/images/fbcalls/fbcalls_banner_bg-c3dbc2e8b9c49e36c40b784bc7880b20.png";